export const LAYOUT_BOXED_TOGGLE = 'LAYOUT_BOXED_TOGGLE'
export const LAYOUT_BOXED_ENABLE = 'LAYOUT_BOXED_ENABLE'
export const LAYOUT_BOXED_DISABLE = 'LAYOUT_BOXED_DISABLE'
export const LAYOUT_IS_MOBILE = 'LAYOUT_IS_MOBILE'
export const LAYOUT_METRICS_CHART = 'LAYOUT_METRICS_CHART'
